module.exports = "//static.hsappstatic.net/ui-images/static-2.319/optimized/transparent_background.svg"